export interface BreadcrumbBase {
    name: string | null;
    caption?: string;
    truncateAfter?: number;
}

export interface BreadcrumbWithTo extends BreadcrumbBase {
    to: string | object;
    onClick?: undefined;
}

export interface BreadcrumbWithOnClick extends BreadcrumbBase {
    to?: undefined;
    onClick: () => void | undefined;
}

export type Breadcrumb = BreadcrumbWithTo | BreadcrumbWithOnClick;

export const useBreadcrumbsStore = defineStore("breadcrumbsStore", {
    state: () => ({
        crumbs: [] as Breadcrumb[],
    }),
    actions: {
        getNumberOfBreadcrumbs() {
            return this.crumbs.length;
        },
        setBreadcrumbs(crumbs: Breadcrumb[]) {
            this.crumbs = crumbs;
        },
        checkAndExtendBreadcrumbsArray(index: number) {
            // check if index is within bounds
            // if not extend the array with empty objects
            if (index >= this.crumbs.length) {
                for (let i = this.crumbs.length; i <= index; i++) {
                    this.crumbs.push({
                        name: null,
                        caption: undefined,
                        to: undefined,
                        onClick: undefined,
                    });
                }
            }
        },
        setBreadcrumbAtIndex(index: number, crumb: Breadcrumb) {
            this.checkAndExtendBreadcrumbsArray(index);
            this.crumbs[index] = crumb;
        },
        setBreadcrumbNameAtIndex(index: number, name: string) {
            this.checkAndExtendBreadcrumbsArray(index);
            this.crumbs[index].name = name;
        },
        appendBreadcrumb(crumb: Breadcrumb) {
            this.crumbs.push(crumb);
        },
        removeBreadcrumbAfterIndex(index: number) {
            this.crumbs.splice(index);
        },
    },
});
